import './ccf-fav-dashboard-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfFavDashboardIconProps extends SvgIconProps {}
/**
 * This icon will be used to display unavailable status of agent
 * @param props - CcfFavDashboardIcon
 * @example - <CcfFavDashboardIcon />
 * @returns SVG of unavailable icon
 */
export function CcfFavDashboardIcon(props: CcfFavDashboardIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M4.00102 5.00127H10.9998V10.0009H4.00102V5.00127Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M10.9998 11.0008H4.00102V13.0006H10.9998V11.0008Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M11.9997 8.00102H15.999V13.0006H11.9997V8.00102Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M15.999 5.00127H11.9997V7.00111H15.999V5.00127Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9985 2.00153H10.9998V1.00161C11.0078 0.8682 10.9875 0.734606 10.9401 0.609677C10.9164 0.547305 10.8863 0.4878 10.8503 0.43208C10.8141 0.376176 10.7721 0.324057 10.7248 0.276759C10.6303 0.182223 10.5168 0.108865 10.3919 0.0614447C10.267 0.0140244 10.1334 -0.00629859 10 0.00169634C9.8666 -0.00629859 9.73302 0.0140244 9.6081 0.0614447C9.48312 0.108865 9.36967 0.182223 9.27521 0.276759C9.18068 0.371233 9.10733 0.484749 9.05991 0.609677C9.0125 0.734606 8.99211 0.8682 9.00017 1.00161V2.00153H1.00153C0.868126 1.99353 0.734543 2.01386 0.609625 2.06128C0.484707 2.1087 0.371201 2.18205 0.276735 2.27659C0.182208 2.37106 0.108856 2.48458 0.0614395 2.60951C0.0140232 2.73444 -0.00629805 2.86803 0.0016962 3.00144C-0.00629805 3.13485 0.0140232 3.26845 0.0614395 3.39338C0.0893278 3.46692 0.126248 3.53649 0.171162 3.60057C0.20259 3.64537 0.237862 3.68742 0.276735 3.7263C0.371201 3.82077 0.484707 3.89419 0.609625 3.94161C0.734543 3.98903 0.868126 4.00935 1.00153 4.00136V15.0004C0.993532 15.1338 1.01385 15.2674 1.06127 15.3924C1.10869 15.5173 1.18204 15.6308 1.27657 15.7253C1.37103 15.8198 1.48454 15.8932 1.60946 15.9406C1.73437 15.988 1.86796 16.0083 2.00136 16.0003H9.00017V18.0002H6.50059C6.23544 18.0002 5.98109 18.1055 5.79362 18.2931C5.60609 18.4805 5.50076 18.7349 5.50076 19.0001C5.50076 19.2653 5.60609 19.5196 5.79362 19.7071C5.98109 19.8947 6.23544 20 6.50059 20H13.4994C13.7646 20 14.0189 19.8947 14.2064 19.7071C14.3939 19.5196 14.4992 19.2653 14.4992 19.0001C14.4992 18.7349 14.3939 18.4805 14.2064 18.2931C14.0189 18.1055 13.7646 18.0002 13.4994 18.0002H10.9998V16.0003H17.9986C18.132 16.0083 18.2656 15.988 18.3905 15.9406C18.5155 15.8932 18.6289 15.8198 18.7234 15.7253C18.8179 15.6308 18.8913 15.5173 18.9387 15.3924C18.9861 15.2674 19.0065 15.1338 18.9985 15.0004V4.00136C19.1319 4.00935 19.2654 3.98903 19.3904 3.94161C19.5153 3.89419 19.6288 3.82077 19.7233 3.7263C19.8178 3.63182 19.8911 3.51831 19.9385 3.39338C19.9859 3.26845 20.0063 3.13485 19.9983 3.00144C20.0063 2.86803 19.9859 2.73444 19.9385 2.60951C19.8911 2.48458 19.8178 2.37106 19.7233 2.27659C19.6288 2.18205 19.5153 2.1087 19.3904 2.06128C19.2654 2.01386 19.1319 1.99353 18.9985 2.00153ZM16.9988 14.0005H3.00119V4.00136H16.9988V14.0005Z"
        fill="white"
        fillOpacity="0.6"
      />
    </SvgIcon>
  );
}

export default CcfFavDashboardIcon;
